/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The streaming mode. 'audio' (default) streams raw audio to output_url via WebSocket. 'transcription' runs real-time speech-to-text and POSTs transcript events to output_url via HTTP webhooks.
 */
export type CreateCalendarBotRequestBodyInputAllOfStreamingConfigAnyOfMode =
  (typeof CreateCalendarBotRequestBodyInputAllOfStreamingConfigAnyOfMode)[keyof typeof CreateCalendarBotRequestBodyInputAllOfStreamingConfigAnyOfMode]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCalendarBotRequestBodyInputAllOfStreamingConfigAnyOfMode = {
  audio: "audio",
  transcription: "transcription"
} as const
